// eslint-disable-next-line import/prefer-default-export
export const baseSortableOptions = {
  draggable: '[data-draggable="true"]',
  filter: '[data-draggable="false"]',
  // Filtered elements are buttons and links that must keep working as clicks. Sortable's default cancels the
  // touchstart on them, and on iPad Safari (desktop user agent, so no pointer events) that swallows the click.
  preventOnFilter: false,
  animation: 100,
  swapThreshold: 1,
  ghostClass: 'sortable-ghost',
};
